export default __webpack_public_path__ + "static/media/benzinga.8e7c6ebe.png";